/* ============
 * Getters for the notification module
 * ============
 *
 * The getters that are available on the
 * notification module.
 */
import { G } from '@2l/utils'

export default {
  isLoaded: (state) => !!state.isLoaded,

  getFirstNotification: G('activeQueue.0')
}
